import { render } from "./MealProduct.vue?vue&type=template&id=094a6941&scoped=true"
import script from "./MealProduct.vue?vue&type=script&lang=js"
export * from "./MealProduct.vue?vue&type=script&lang=js"

import "./MealProduct.vue?vue&type=style&index=0&id=094a6941&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094a6941"]])

export default __exports__